import { z } from 'zod';

import { nameRegex } from './utils';

export const newsletterSignUpSchema = z.object({
  firstname: z
    .string()
    .trim()
    .max(36, { message: 'Maximum 36 characters allowed' })
    .min(1, { message: 'First name is required' })
    .regex(nameRegex, {
      message: "First name can't contain special characters",
    }),
  lastname: z
    .string()
    .trim()
    .max(36, { message: 'Maximum 36 characters allowed' })
    .min(1, { message: 'Last name is required' })
    .regex(nameRegex, { message: "Last name can't contain special characters" }),
  email: z
    .string()
    .trim()
    .min(1, { message: 'Email is required' })
    .max(254, { message: 'Email cannot exceed 254 characters' })
    .email('Invalid email address'),
});
